export const NavbarHeight = 64;
export const SidebarWidth = 256;
